import { useLocation, useNavigate } from "react-router-dom";
import styles from "./VolunteerHomepage.module.scss";
import { useTranslation } from "../i18n";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useContext, useEffect, useState } from "react";
import { Button } from "@mui/material";
import { VictoryIcon } from "../components/Icons/Victory";
import { AuthContext } from "../context/AuthContext";
import { useAlert } from "../context/AlertContext";

interface LocationState {
  from?: string;
}

export const VolunteerHomepage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const from = (location.state as LocationState)?.from;
  const authContext = useContext(AuthContext);
  const currentUser = authContext?.currentUser;
  const { setAlert } = useAlert();

  const [dialogOpen, setDialogOpen] = useState<boolean>(
    from?.includes("register") ? true : false,
  );

  const recommendedEventId = currentUser?.userRecommendedEvent
    ? (currentUser.userRecommendedEvent as { current_event_id?: string }).current_event_id
    : undefined;

  const handleRecommendClick = () => {
    if (recommendedEventId) {
      navigate(`/event/${recommendedEventId}`);
    } else {
      setAlert(
        true,
        "info",
        t("alerts.noRecommendedEvent"),
      );
      navigate("/volunteer/events");
    }
    setDialogOpen(false);
  };

  useEffect(() => {
    const root = document.getElementById("root");
    if (root) {
      if (dialogOpen) {
        root.classList.add("dialog-blur");
      } else {
        root.classList.remove("dialog-blur");
      }
    }
    return () => {
      if (root) {
        root.classList.remove("dialog-blur");
      }
    };
  }, [dialogOpen]);

  return (
    <div className={styles.volunteerHp}>
      <Dialog
        open={dialogOpen}
        disableEscapeKeyDown
        onClose={() => {}}
        slotProps={{
          backdrop: {
            onClick: () => {},
          },
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xs"
        className={styles.dialog}
      >
        <DialogTitle id="alert-dialog-title" className={styles.title}>
          <VictoryIcon />
          {t("volunteer.registeredTitle")}
        </DialogTitle>
        <DialogContent className={styles.content}>
          <DialogContentText id="alert-dialog-description">
            {t("volunteer.registeredText")}
          </DialogContentText>
        </DialogContent>
        <DialogActions className={styles.actions}>
          <Button variant="outlined" onClick={handleRecommendClick}>
            {t("volunteer.recommend")}
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              navigate("/volunteer/events");
              setDialogOpen(false);
            }}
          >
            {t("volunteer.chooseMyself")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

